// Categorical series colours for every chart in the dashboard (bar, line, pie).
// The order is fixed and checked for colour-blind separation; light and dark use
// their own steps of the same hues.
const SERIES_COLORS_LIGHT = ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#6250d6', '#e34948'];
const SERIES_COLORS_DARK = ['#3987e5', '#d95926', '#199e70', '#c98500', '#d55181', '#008300', '#9085e9', '#e66767'];

/**
 * Colour of the series at `index` (0-based). Used by the chat chart formatters
 * (BarChartFormatter, LineChartFormatter, PieChartFormatter).
 * @param {number} index - Position of the series or slice
 * @param {boolean} isDark - Whether the dark theme is on
 * @returns {string} Hex colour
 */
export const getChartSeriesColor = (index, isDark) => {
  const colors = isDark ? SERIES_COLORS_DARK : SERIES_COLORS_LIGHT;
  return colors[index % colors.length];
};
